import React from "react";
import { Route, Switch } from "react-router-dom";

import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import { ClientCreatePage } from "./create_page";
import { ClientDetailPage } from "./detail_page";
import { ClientEditPage } from "./edit_page";
import { ClientListPage } from "./list_page";

export const ClientMainPage: React.FC = () => {
  return (
    <Switch>
      <Route path={ROUTES.client} exact>
        <ClientListPage />
      </Route>

      <Route path={Routing.generateCreateRoute(ROUTES.client)}>
        <ClientCreatePage />
      </Route>

      <Route path={Routing.generateEditRoute(ROUTES.client)}>
        <ClientEditPage />
      </Route>

      <Route path={Routing.generateDetailRoute(ROUTES.client)}>
        <ClientDetailPage />
      </Route>
    </Switch>
  );
};
